import React from "react";
import { useDispatch, useSelector } from "react-redux";
import formatDate from "../utilities/formatDate";
import { logOut } from "../redux-store/slices/authSlice";
import { useNavigate } from "react-router-dom";

const UserMenu = () => {
  const { userDetails } = useSelector((state) => state.auth);

  let loginDate = new Date(userDetails?.lastLogin);

  const distpatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = () => {
    distpatch(logOut());
    navigate("/");
  };
  return (
    <div
      style={{ backgroundColor: "#F1F1F1", padding: "20px", height: "100%" }}
      className="w-64 flex flex-col justify-between gap-5"
    >
      <div>
        <h2 style={{ color: "#6A6A6A", textAlign: "center" }}>
          OFFICE DETAILS
        </h2>
        <p>
          <strong style={{ color: "#1F9BE9", display: "block" }}>Name:</strong>
          {/* {userDetails?.username} */}
          {userDetails?.username.charAt(0).toUpperCase() +
            userDetails?.username.slice(1)}
        </p>
        <p>
          <strong style={{ color: "#1F9BE9", display: "block" }}>
            Designation:
          </strong>
          {userDetails?.userDesig}
        </p>
        <p>
          <strong style={{ color: "#1F9BE9", display: "block" }}>Role:</strong>
          {userDetails?.userRole}
        </p>
        <p>
          <strong style={{ color: "#1F9BE9", display: "block" }}>
            Sub-Registrar Office:
          </strong>
          ({userDetails?.sroName})
        </p>
        <p>
          <strong style={{ color: "#1F9BE9", display: "block" }}>Date:</strong>

          {formatDate(userDetails?.lastLogin, "dd/MM/yyyy")}
        </p>
        <p>
          <strong style={{ color: "#1F9BE9", display: "block" }}>
            Financial Year:
          </strong>
          {loginDate.getFullYear()} - {loginDate.getFullYear() + 1}
        </p>
      </div>
      <button
        style={{
          backgroundColor: "#1F9BE9",
          color: "#FFF",
          padding: "10px 20px",
          borderRadius: "5px",
          border: "none",
          cursor: "pointer",
          marginTop: "20px",
          textAlign: "center",
        }}
        onClick={() => {
          handleLogout();
        }}
      >
        Logout
      </button>
    </div>
  );
};

export default UserMenu;
